import * as React from 'react';
import { Typography } from '@mui/material';
import { Trans, useTranslation } from "react-i18next";
import { createTheme } from '@mui/material/styles';


const theme = createTheme({
  typography: {
    /*title_fat: {
      fontFamily: 'Arista-Pro-Fat-trial',
      fontSize: '32pt',
      fontWeight: 500,
      color: 'primary',
      lineHeight: '32pt',
      '@media (max-width: 992px)': {
        fontSize: '26pt',
      },
    },
    title_light: {
      fontFamily: 'Arista-Pro-Light-trial',
      fontSize: '14pt',
      fontWeight: 100,
      color: 'orange',
      lineHeight: '16pt',
      '@media (max-width: 992px)': {
        fontSize: '18pt',
      },
    },
    title_green: {
      fontFamily: 'Arista-Pro-Light-trial',
      fontSize: '12pt',
      fontWeight: 100,
      color: 'green',
      lineHeight: '14pt',
      '@media (max-width: 992px)': {
        fontSize: '12pt',
      },
    },*/
    header: {
      fontFamily: 'Nexa Book',
      fontSize: '20pt',
      lineHeight: '20pt',
      '@media (max-width: 992px)': {
        fontSize: '18pt',
        lineHeight: '20pt',
      },
    },
    big: {
      fontFamily: 'Arista Bold',
      textTransform: 'uppercase',
      fontSize: '22pt',
      lineHeight: '20pt',
    },
    normal: {
      fontFamily: 'Arista',
      fontSize: '20pt',
      lineHeight: '20pt',
      textTransform: 'uppercase',
      fontWeight: 200,

      /*'@media (max-width: 992px)': {
        fontSize: '18pt',
        lineHeight: '20pt',
      },*/
    },
    small: {
      fontFamily: 'Arista Light',
      /*fontFamily: 'Arista-Pro-Fat-trial',*/
      /*fontFamily: 'Arista-Pro-Bold-trial',*/
      /*fontFamily: 'Arista-Pro-Alternate-Light-trial',*/
      /*fontFamily: 'Arista-Pro-Alternate-Fat-trial',*/
      /*fontFamily: 'Arista-Pro-Alternate-Bold-trial',*/
      fontSize: '14pt',
      lineHeight: '16pt',
      fontWeight: 500,
      '@media (max-width: 992px)': {
        fontSize: '14pt',
        lineHeight: '14pt',
      },
    },
    card: {
      fontFamily: 'Arista',
      fontSize: '20pt',
      lineHeight: '20pt',
      textTransform: 'uppercase',
      fontWeight: 200,

      /*'@media (max-width: 992px)': {
        fontSize: '18pt',
        lineHeight: '20pt',
      },*/
    },
  },

});

export function Title({ text, color, variant }) {

  const { t } = useTranslation();

  return (
    <div className="pt-4 pb-2 paragrah">
      <Typography
        theme={theme}
        variant={variant}
        sx={{ color: color }}
      >
        <Trans
          i18nKey={text}
          components={{
            italic: <i />,
            strong: <strong />,
            underline: <u />,
          }}
        />
      </Typography>
    </div>
  )
}

export default Title